let product_limit = 0;
let product_added = 0;
const product_obj = {};

document.addEventListener('DOMContentLoaded', function () {
  const minicart_wrapper = document.querySelector('.product-minicart-pmc');
  const tabs_wrapper = document.querySelector('.pmc-tabs-wrapper');
  const product_selected_grid = document.querySelector('.product_selected_grid');
  const atc_btn = document.querySelector('#bundle-addtocart');
  const pl_disclaimer = document.querySelector('.pl_disclaimer');
  const limitfull_popup = document.querySelector('.limitfull-popup-main');
  const limitpopup_overlay = document.querySelector('.limitfull-popup-overlay');
  const limitfull_popupclose = document.querySelector('.limitfull-popupclose');

  const pmc_info_popup = document.querySelector('.pmc_info_popup');
  const infopopup_overlay = document.querySelector('.pmc-info_popup_overlay');
  const pmc_info_popup_close = document.querySelector('.pmc_info_popup_close');
  const pmc_info_close = document.querySelector('.pmc-info-close');

  const scrollContainer = document.querySelector('.topic-scroll-container');
  const leftBtn = document.querySelector('.topic-scroll-btn.left');
  const rightBtn = document.querySelector('.topic-scroll-btn.right');

  leftBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: -400, behavior: 'smooth' });
    leftBtn.style.display = 'none';
  });
  
  rightBtn.addEventListener('click', () => {
    scrollContainer.scrollBy({ left: 400, behavior: 'smooth' });
    leftBtn.style.display = 'flex';
  });

  // Set product limit from attribute
  if (minicart_wrapper) {
    product_limit = parseInt(minicart_wrapper.getAttribute('product-limit')) || 0;
  }

  // Tabs functionality
  const topic_tabs = document.querySelectorAll('.pmc-topic-item');
  topic_tabs.forEach(btn => {
    btn.addEventListener('click', function () {
      const tab = btn.getAttribute('tab');

      // Update active tab button
      topic_tabs.forEach(el => el.classList.remove('active_topic'));
      btn.classList.add('active_topic');

      // Update tab content
      document.querySelectorAll('.pmc-tab-item').forEach(tabItem => {
        tabItem.classList.remove('active_tabData');
      });

      const tab_data = document.querySelector(`.pmc-tab-item[tab="${tab}"]`);
      if (tab_data) tab_data.classList.add('active_tabData');
    });
  });

  if(limitfull_popupclose){
    limitfull_popupclose.addEventListener('click',function(){
      limitfull_popup.style.display = 'none';
    });
  }
  if(limitpopup_overlay){
    limitpopup_overlay.addEventListener('click',function(){
      limitfull_popup.style.display = 'none';
    });
  }

  if(infopopup_overlay){
    infopopup_overlay.addEventListener('click',function(){
      pmc_info_popup.style.display = 'none';
    });
  }
  if(pmc_info_popup_close){
    pmc_info_popup_close.addEventListener('click',function(){
      pmc_info_popup.style.display = 'none';
    });
  }
  if(pmc_info_close){
    pmc_info_close.addEventListener('click',function(){
      pmc_info_popup.style.display = 'none';
    });
  }

  // Variant selection logic
  const variant_fields = document.querySelectorAll('.tab-variant-input');
  variant_fields.forEach(input => {
    input.addEventListener('change', () => {

      const topic = input.dataset.topic;
      const id = input.dataset.variantId;
      const image = input.dataset.image;
      const name = input.dataset.name;

      // ensure topic exists
      if (!product_obj[topic]) {
        product_obj[topic] = { products: [] };
      }
      const topicData = product_obj[topic];

      if (input.checked) {
        product_added += 1;
        input.classList.add('variant_added');

      // only add if not already present
      if (!topicData.products.some(p => p.id === id)) {
        topicData.products.push({ id, topic, image, name });
      }
      } else {
        product_added = Math.max(0, product_added - 1); // prevent negative
        input.classList.remove('variant_added');

        // remove the variant from topicData
        topicData.products = topicData.products.filter(p => p.id !== id);
        if (topicData.products.length === 0) {
            delete product_obj[topic];
            const tab = document.querySelector(`.pmc-topic-item[tab="${topic}"]`);
            if (!tab) return;
            const product_count = tab.querySelector(".pmc-item-count");
            if (product_count) {
              product_count.textContent = 0;
            }
            tab.classList.remove('show_counter');
        }
      }

      showItems();

      // Disable/enable inputs based on product limit
      if (product_added >= product_limit) {
        tabs_wrapper.querySelectorAll('input:not(.variant_added)').forEach(inp => {
          inp.setAttribute('disabled', true);
        });
      } else {
        tabs_wrapper.querySelectorAll('input').forEach(inp => {
          inp.removeAttribute('disabled');
        });
      }

      if(product_added > 0){
        atc_btn.removeAttribute('disabled');
        pl_disclaimer.style.display = 'block';
      }else{
        atc_btn.setAttribute('disabled', true);
        pl_disclaimer.style.display = 'none';
      }

    });
  });

  function showItems() {
    // clear the grid first
    product_selected_grid.innerHTML = '';

    if (Object.keys(product_obj).length == 0) {
      document.querySelector('.pmc-selected-items').classList.remove('show_products');
    } 
    else {
          Object.entries(product_obj).forEach(([topicKey, topic]) => {
              document.querySelector('.pmc-selected-items').classList.add('show_products');
          
              if (!Array.isArray(topic.products)) return;

              const tab = document.querySelector(`.pmc-topic-item[tab="${topicKey}"]`);
              if (!tab) return;

              const product_count = tab.querySelector(".pmc-item-count");

              // Update count or remove counter if empty
              if (topic.products.length > 0) {
                if (product_count) product_count.textContent = topic.products.length;
                tab.classList.add('show_counter');
              } else {
                if (product_count) product_count.textContent = '';
                tab.classList.remove('show_counter');
              }

              // render selected products
              topic.products.forEach(product => {
                const { image, name, id } = product;

                const itemHTML = `
                  <div class="selected_item" data-id="${id}" data-topic="${topicKey}">
                    <div class="selected_item_img_wrap">
                      <img src="${image || ''}" width="44px" height="44px" class="selected_item_img" alt="${name || ''}"/>
                      <svg class="product_remove_btn" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="22" height="22" rx="11" fill="white"/>
                        <path d="M14.6405 14.1097C14.6754 14.1445 14.703 14.1859 14.7219 14.2314C14.7407 14.2769 14.7504 14.3257 14.7504 14.375C14.7504 14.4242 14.7407 14.473 14.7219 14.5186C14.703 14.5641 14.6754 14.6054 14.6405 14.6403C14.6057 14.6751 14.5643 14.7028 14.5188 14.7216C14.4733 14.7405 14.4245 14.7502 14.3752 14.7502C14.3259 14.7502 14.2771 14.7405 14.2316 14.7216C14.1861 14.7028 14.1447 14.6751 14.1099 14.6403L11.0002 11.5301L7.89052 14.6403C7.82016 14.7106 7.72472 14.7502 7.62521 14.7502C7.5257 14.7502 7.43026 14.7106 7.3599 14.6403C7.28953 14.5699 7.25 14.4745 7.25 14.375C7.25 14.2755 7.28953 14.18 7.3599 14.1097L10.4701 11L7.3599 7.89028C7.28953 7.81991 7.25 7.72448 7.25 7.62496C7.25 7.52545 7.28953 7.43002 7.3599 7.35965C7.43026 7.28929 7.5257 7.24976 7.62521 7.24976C7.72472 7.24976 7.82016 7.28929 7.89052 7.35965L11.0002 10.4698L14.1099 7.35965C14.1803 7.28929 14.2757 7.24976 14.3752 7.24976C14.4747 7.24976 14.5702 7.28929 14.6405 7.35965C14.7109 7.43002 14.7504 7.52545 14.7504 7.62496C14.7504 7.72448 14.7109 7.81991 14.6405 7.89028L11.5304 11L14.6405 14.1097Z" fill="#0A3A60"/>
                      </svg>
                    </div>
                    <span class="selected_item_name">${name || ''}</span>
                  </div>`;
                product_selected_grid.insertAdjacentHTML('beforeend', itemHTML);
              });
          });

          if (product_added < product_limit) {
            const remains_product = product_limit - product_added;
            console.log("remains_product",remains_product);
            let itemHTML;
            for(var i=0; i<remains_product; i++){
              itemHTML = `
                  <div class="selected_item">
                    <div class="selected_item_img_wrap">
                      <img src="https://cdn.shopify.com/s/files/1/0760/1320/7787/files/Stoffmuster.svg?v=1763552205" width="44px" height="44px" class="selected_item_img" alt="empty"/>
                    </div>
                    <span class="selected_item_name"></span>
                  </div>`;
                product_selected_grid.insertAdjacentHTML('beforeend', itemHTML);
            }
            // const remain = `<div class="remaining_count">${product_added} von ${product_limit}</>`;
            // product_selected_grid.insertAdjacentHTML('beforeend', remain);
          }


    }

  }

});

document.addEventListener('click', (event) => {
  const disbaled_label = event.target.closest('.tab-variant-input[disabled] + label');
  const product_remove = event.target.closest('.product_remove_btn');
  const variant_info = event.target.closest('.tab-variant-info');
  const variant_imgBtn = event.target.closest('.tab-variant-image');
  const bundl_ATC = event.target.closest('#bundle-addtocart');

  if (product_remove) {
    const parent = product_remove.closest('.selected_item');
    if (!parent) return;

    const id = parent.getAttribute('data-id');
    if (!id) return;

    // Find the matching variant input
    const input = document.querySelector(`.tab-variant-input[data-variant-id="${id}"]`);
    if (input) {
      // Uncheck it and trigger its change event manually
      input.checked = false;
      input.dispatchEvent(new Event('change'));
    }
  }

  if(disbaled_label){
    console.log('clicked');
    document.querySelector('.limitfull-popup-main').style.display = 'block';
  }

  if(variant_imgBtn){
    const id = variant_imgBtn.getAttribute('var-id');
    buildPopup(id);
  }

  if (variant_info) {
    const id = variant_info.getAttribute('var-id');
    buildPopup(id);
  }

  if (bundl_ATC) {
    bundl_ATC.classList.add('loader_active');
  
    const items = [];
  
    async function processBundle() {
  
      // Wait for cart clear
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
  
      // Build items array
      Object.entries(product_obj).forEach(([key, topic]) => {
        if (topic.products && Array.isArray(topic.products)) {
          topic.products.forEach(product => {
            if (product.id) {
              items.push({
                id: product.id,
                quantity: product.quantity || 1
              });
            }
          });
        }
      });
  
      if (items.length === 0) {
        console.error("❌ No items to add");
        bundl_ATC.classList.remove('loader_active');
        return;
      }
  
      // ✅ Add items AFTER cart cleared
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
  
      const cartData = await res.json();
  
      bundl_ATC.classList.remove('loader_active');
  
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartData,
            openMiniCart: true,
            replacementDelay: 0
          }
        })
      );

    }
  
    processBundle().catch(err => {
      bundl_ATC.classList.remove('loader_active');
      console.error("❌ Error adding bundle:", err);
    });
  }

});

function buildPopup(id){
  const popupData = document.querySelector(`.popup-data[var-id="${id}"]`);

  if (!popupData) return;

  const description = popupData.innerHTML;
  const images = popupData.getAttribute('var-images').split(',');
  const title = popupData.getAttribute('var-title');

  const popupSlider = document.querySelector('.pmc-img-wrapper');
  const popupWrapper = popupSlider.querySelector('.swiper-wrapper');

  // REMOVE OLD SLIDES
  popupWrapper.innerHTML = '';

  // ADD NEW SLIDES
  images.forEach((img) => {
    if(!img) return;
    const slide = document.createElement('div');
    slide.classList.add('swiper-slide');
    slide.innerHTML = `<img src="${img.trim()}" />`;
    popupWrapper.appendChild(slide);
  });

  // INIT / RE-INIT SWIPER
  if (window.pmcPopupSwiper) {
    window.pmcPopupSwiper.destroy(true, true);
  }

  window.pmcPopupSwiper = new Swiper('.pmc-img-wrapper', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: false, // hide pagination
    navigation: {
      nextEl: '.pmc-next',
      prevEl: '.pmc-prev',
    },
  });

  // TEXT + DESCRIPTION UPDATE
  const titleEl = document.querySelector('.pmc-popup_product_title');
  const popupDescription = document.querySelector('.pmc-popup_product_description');
  const popup = document.querySelector('.pmc_info_popup');

  if (titleEl) titleEl.textContent = title || '';
  if (popupDescription) popupDescription.innerHTML = description;
  if (popup) popup.style.display = 'block';
}

